/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs */

const en__field_enum_csjensblank_bewerbungsprozess_untertuetzung41 = /** @type {(inputs: _Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`application process support`)
};

const de__field_enum_csjensblank_bewerbungsprozess_untertuetzung41 = /** @type {(inputs: _Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung im Bewerbungsprozess (Bewerbungsunterlagen/ Interview)`)
};

/**
* | output |
* | --- |
* | "application process support" |
*
* @param {_Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_bewerbungsprozess_untertuetzung41 = /** @type {((inputs?: _Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Bewerbungsprozess_Untertuetzung41Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_bewerbungsprozess_untertuetzung41(inputs)
	return de__field_enum_csjensblank_bewerbungsprozess_untertuetzung41(inputs)
});
export { _field_enum_csjensblank_bewerbungsprozess_untertuetzung41 as "_field_enum_CSJENSBLANK_BEWERBUNGSPROZESS_UNTERTUETZUNG" }